import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Grid } from '@mui/material';
import img1 from './../../../assets/images/hero/img1.jpg';
import img2 from './../../../assets/images/hero/img2.jpg';
import img3 from './../../../assets/images/hero/img3.jpg';
import img4 from './../../../assets/images/hero/img4.jpg';
import { FaCheck } from "react-icons/fa6";
import { IoMdCall } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import './HeroSection.scss';
import CustomButton from '../../CustomButton/CustomButton';
import vector from './../../../assets/images/hero/Vector 748.png';
import { useDispatch, useSelector } from 'react-redux';
import { fetchWebsiteSettings } from './../../../redux/slices/settings/SliderSlice';
import Loading from '../../UI/Loading/Loading';

const HeroSection = ({ t, direction }) => {
    const dispatch = useDispatch();
    const imageChunks = useSelector((state) => state.sliders.imageChunks) || [];


    const status = useSelector((state) => state.sliders.status);
    const [activeSlide, setActiveSlide] = useState(0);
    const [images, setImages] = useState([]);
    const [fadeClass, setFadeClass] = useState('fade-in');
    const navigate = useNavigate();
    // Fetch images when the component mounts
   
    function useFetchWebsiteSettings(dispatch, status) {
        useEffect(() => {
            if (status === 'idle') {
                dispatch(fetchWebsiteSettings()).catch((error) => {
                    console.error('Error fetching website settings:', error);
                });
            }
        }, [dispatch, status]);
    }
    useFetchWebsiteSettings(dispatch, status);
    useEffect(() => {
        if (imageChunks.length > 0) {
            // Create a copy of imageChunks with a static image added to the odd chunks
            const newImageChunks = imageChunks.map((chunk) => {
                // If the chunk has an odd number of images, add a static image
                if (chunk.length % 2 !== 0) {
                    return [...chunk, img1];  // Add static image to this chunk
                }
                return chunk;  // No changes for even chunks
            });

            // Update the state with the new image chunks
            setImages(newImageChunks);
        } else {
            // If no imageChunks are fetched, use default images
            setImages([img1, img2, img3, img4]);  // Static fallback images
        }
    }, [imageChunks]);

    // Set an interval to cycle through the image chunks
    useEffect(() => {
        if (images.length > 0) {
            const slideInterval = setInterval(() => {
                setFadeClass('fade-out'); // Trigger fade-out effect before changing image
                setTimeout(() => {
                    setActiveSlide((prev) => (prev + 1) % images.length);
                    setFadeClass('fade-in'); // Trigger fade-in effect after changing image
                }, 1000); // Wait for fade-out animation to complete
            }, 3000);
            return () => clearInterval(slideInterval); // Cleanup the interval on unmount
        }
    }, [images]);
    const handleButtonClick = () => {
        navigate('/request-price');
    };

    if (status === 'loading') {
        return <Loading />;
    }
    return (

        <div data-aos="fade-up">

            <Box className="hero">
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: 'var(--primary-color)',
                        padding: '13px',
                        color: 'white',
                        width: '100%',
                        pl: { xs: '20px', md: '30px', xl: '70px' },
                        pr: { xs: '20px', md: '30px', xl: '70px' },
                        pt: { xs: '20px', md: '30px', xl: '70px' },
                        pb: { xs: '20px', md: '30px', xl: '70px' },

                    }}>

                    <Grid
                        container
                        spacing={4}
                        sx={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            height: '100%',
                            padding: "0px",
                            margin: "0px",

                        }}
                    >
                        {/* Left Image */}
                        <Grid
                            item
                            xs={12}
                            md={3}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                height: 'auto',
                                position: 'relative',
                                borderRadius: '50px 50px 0px 50px',
                                paddingLeft: "0px !important",
                                paddingRight: "0px !important",
                                paddingTop: "0px !important",
                            }}
                        >
                            {/* Image */}
                            <img
                                src={images[activeSlide] ? images[activeSlide][0] : img2}
                                alt="Left Service "
                                className={`responsive-img ${fadeClass}`}
                                loading="lazy"
                                style={{
                                    borderRadius: '50px 50px 0px 50px',
                                    position: 'relative', // Position image relative so the shadow will appear beneath it
                                    zIndex: 1, // Ensure image appears above the shadow

                                }}
                            />
                        </Grid>

                        {/* Center Content */}
                        <Grid
                            item
                            xs={12}
                            md={5}
                            sx={{
                                textAlign: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: 'auto',
                                paddingLeft: "0px !important",
                                paddingRight: "0px !important",
                                paddingTop: "0px !important",

                            }}
                        >
                            {/* Top Text */}
                            <Typography
                                variant="body2"
                                sx={{
                                    fontSize: '18px',
                                    fontWeight: 700,
                                    marginBottom: '15px',
                                    color: '#D9D7D7',
                                    pt: 2
                                }}
                            >
                                {t.topText}
                            </Typography>

                            {/* Main Heading */}
                            <Typography
                                sx={{
                                    fontWeight: 700,
                                    fontSize: { xs: '22px', sm: '25px', lg: '30px', xl: '42px' },
                                    marginBottom: '20px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    textAlign: 'center',
                                    width: '100%',
                                }}
                            >
                                {direction === "ltr" ? (
                                    <span>Need repairs,<span className='highlight'>  cleaning</span>, or improvements for your home?
                                    </span>

                                ) : (
                                    <span>
                                        {t.mainHeadingLine1}
                                    </span>
                                )}

                                {direction === "ltr" ? (
                                    <span>Aween provides <span className='highlight'> fast</span>, high-quality maintenance and <span className='highlight'>upgrades!</span>
                                    </span>
                                ) : (
                                    <span>
                                        {t.with} <span className="highlight">{t.Aween}{" "}</span>
                                        {t.subHeadingLine1}{' '}
                                        <span className="highlight">{t.Quality}</span> {t.speed}{' '}
                                        <span className="highlight">{' '}{t.Excellence}</span>
                                    </span>
                                )}

                            </Typography>

                            {/* Features Section */}
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    flexWrap: 'wrap',
                                    gap: '15px',
                                    marginTop: '20px',
                                    color: 'var(--bg-color-light)',

                                }}
                            >
                                {t.features.map((feature, index) => (
                                    <Box key={index} sx={{
                                        display: 'flex', alignItems: 'center', gap: '8px',
                                        flexDirection: direction === "ltr" ? "row-reverse" : "row",
                                    }}>
                                        <Typography sx={{ fontSize: '16px', fontWeight: 500 }}>
                                            {feature}
                                        </Typography>
                                        <FaCheck sx={{ fontSize: { xs: '14px', sm: '18px', lg: '20px' } }} />
                                    </Box>
                                ))}
                            </Box>

                            {/* Button */}
                            <CustomButton
                                text={t.buttonText}
                                icon={IoMdCall}
                                onClick={handleButtonClick}
                                direction={direction}
                            />
                        </Grid>

                        {/* Right Image */}
                        <Grid
                            item
                            xs={12}
                            md={3}
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                height: 'auto',
                                borderRadius: '50px 50px 0px 50px',
                                position: 'relative',
                                paddingLeft: "0px !important",
                                paddingRight: "0px !important",
                                paddingTop: "0px !important",

                            }}
                        >

                            <img
                                src={images[activeSlide] ? images[activeSlide][1] : img3}
                                alt="Right Service "
                                className={`responsive-img ${fadeClass}`}
                                loading="lazy"
                                style={{
                                    borderRadius: '50px 50px 50px 0px',
                                    position: 'relative', // Position image relative so the shadow will appear beneath it
                                    zIndex: 1, // Ensure image appears above the shadow
                                }}
                            />

                        </Grid>
                    </Grid>
                </Box>
                <Box
                    sx={{
                        display: { md: "flex", xs: "none" },
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <img
                        src={vector}
                        alt="Vector"
                         loading="lazy"
                        style={{
                            maxWidth: '100%',
                            width: '48%',
                            height: 'auto',
                            marginTop: "-4px"
                        }}
                    />
                </Box>


            </Box>
        </div>
    );
};

export default HeroSection;
